
var Globalize = require('globalize/dist/globalize-runtime');
require('globalize/dist/globalize-runtime/number');
require('globalize/dist/globalize-runtime/plural');
require('globalize/dist/globalize-runtime/message');
require('globalize/dist/globalize-runtime/date');
var validateParameterTypeNumber = Globalize._validateParameterTypeNumber;
var validateParameterPresence = Globalize._validateParameterPresence;
var numberRound = Globalize._numberRound;
var numberFormat = Globalize._numberFormat;
var numberFormatterFn = Globalize._numberFormatterFn;
var validateParameterTypeString = Globalize._validateParameterTypeString;
var numberParse = Globalize._numberParse;
var numberParserFn = Globalize._numberParserFn;
var pluralGeneratorFn = Globalize._pluralGeneratorFn;
var validateParameterTypeMessageVariables = Globalize._validateParameterTypeMessageVariables;
var messageFormat = Globalize._messageFormat;
var messageFormatterFn = Globalize._messageFormatterFn;
var validateParameterTypeDate = Globalize._validateParameterTypeDate;
var dateToPartsFormat = Globalize._dateToPartsFormat;
var dateToPartsFormatterFn = Globalize._dateToPartsFormatterFn;
var dateFormat = Globalize._dateFormat;
var dateFormatterFn = Globalize._dateFormatterFn;
var dateTokenizer = Globalize._dateTokenizer;
var dateParse = Globalize._dateParse;
var dateParserFn = Globalize._dateParserFn;

Globalize.a1444431210 = numberFormatterFn(["",,2,0,0,,,,,,"","00","-00","-","",numberRound(),"∞","NaN",{".":",",",":" ","%":"%","+":"+","-":"-","E":"E","‰":"‰"},]);
Globalize.a834538858 = numberFormatterFn(["",,4,0,0,,,,,,"","0000","-0000","-","",numberRound(),"∞","NaN",{".":",",",":" ","%":"%","+":"+","-":"-","E":"E","‰":"‰"},]);
Globalize.b1200342102 = numberFormatterFn(["",,1,0,0,,,,,,"","0","-0","-","",numberRound(),"∞","NaN",{".":",",",":" ","%":"%","+":"+","-":"-","E":"E","‰":"‰"},]);
Globalize.b165205711 = numberParserFn([{",":"."," ":",","%":"%","+":"+","-":"-","E":"E","‰":"‰"},,{"infinity":/^∞/,"nan":/^NaN/,"negativePrefix":/^-/,"negativeSuffix":/^/,"number":/^\d+/,"prefix":/^/,"suffix":/^/}]);
Globalize.a2001260574 = pluralGeneratorFn(function(n
) {
  var s = String(n).split('.'), i = s[0];
  return ((i == 0
          || i == 1)) ? 'one' : 'other';
});
Globalize.b1224747052 = messageFormatterFn((function(  ) {
  return function(d) { return "Iniciar sessão"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.b226958602 = messageFormatterFn((function(  ) {
  return function(d) { return "Iniciar sessão"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a949150261 = messageFormatterFn((function(  ) {
  return function(d) { return "Endereço de e-mail"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a490844932 = messageFormatterFn((function(  ) {
  return function(d) { return "Palavra-passe"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a39066275 = messageFormatterFn((function(  ) {
  return function(d) { return "Este dispositivo é público ou partilhado"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.b177324580 = messageFormatterFn((function(  ) {
  return function(d) { return "Está a utilizar um dispositivo que não lhe pertence? Selecione esta caixa para reduzir o tempo da sessão antes de a mesma ser encerrada automaticamente."; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a1900595575 = messageFormatterFn((function(  ) {
  return function(d) { return "Manter a sessão iniciada"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.b773798823 = messageFormatterFn((function(  ) {
  return function(d) { return "Ao marcar esta caixa, a sua conta permanecerá ativa neste dispositivo até que termine a sessão. Não selecione esta opção em dispositivos partilhados."; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.b21827681 = messageFormatterFn((function(  ) {
  return function(d) { return "Esqueceu-se da palavra-passe?"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.b2004068080 = messageFormatterFn((function(  ) {
  return function(d) { return "Continuar"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a614330851 = messageFormatterFn((function(  ) {
  return function(d) { return "Cancelar"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a232575430 = messageFormatterFn((function(  ) {
  return function(d) { return "Voltar"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a1439981768 = messageFormatterFn((function(  ) {
  return function(d) { return "Atualizar"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.b557838835 = messageFormatterFn((function(  ) {
  return function(d) { return "Ao iniciar sessão, confirma que aceita os <a href=" + d["1"] + " " + d["3"] + ">Termos e Condições</a> e a <a href=" + d["2"] + " " + d["4"] + ">Declaração de Privacidade</a> do " + d["0"] + "."; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.b810369163 = messageFormatterFn((function(  ) {
  return function(d) { return "Ao iniciar sessão, confirma que aceita os <a href=" + d["1"] + " " + d["5"] + ">Termos e Condições</a> e a <a href=" + d["2"] + " " + d["6"] + ">Declaração de Privacidade</a> do " + d["0"] + ", bem como os <a href=" + d["3"] + " " + d["7"] + ">Termos e Condições do programa " + d["4"] + "</a>."; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.b1935648189 = messageFormatterFn((function(  ) {
  return function(d) { return "Ao iniciar sessão, está também a aderir ao programa " + d["4"] + ". Além disso, confirma que aceita os <a href=" + d["1"] + " " + d["5"] + ">Termos e Condições</a> e a <a href=" + d["2"] + " " + d["6"] + ">Declaração de Privacidade</a> da " + d["0"] + ", bem como os <a href=" + d["3"] + " " + d["7"] + ">Termos e Condições do programa " + d["4"] + "</a>."; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a1103756440 = messageFormatterFn((function(  ) {
  return function(d) { return "A sua conta foi colocada em pausa durante uma verificação de segurança de rotina. As suas informações estão seguras. No entanto, deve redefinir a sua palavra-passe. Para o fazer, selecione a opção “Esqueceu-se da palavra-passe?” indicada abaixo. Depois, poderá voltar a iniciar sessão sem problemas."; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.b5553710 = messageFormatterFn((function(  ) {
  return function(d) { return "O e-mail e a palavra-passe não coincidem. Tente novamente."; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.b1545433655 = messageFormatterFn((function(  ) {
  return function(d) { return "Ocorreu um erro."; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.b450513521 = messageFormatterFn((function(  ) {
  return function(d) { return "Ocorreu um erro. Aguarde um momento e tente novamente."; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.b2039642195 = messageFormatterFn((function(  ) {
  return function(d) { return "Introduza o seu endereço de e-mail."; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a97638206 = messageFormatterFn((function(  ) {
  return function(d) { return "Introduza um endereço de e-mail válido."; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a1520572796 = messageFormatterFn((function(  ) {
  return function(d) { return "Introduza a sua palavra-passe."; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a1647748902 = messageFormatterFn((function(  ) {
  return function(d) { return "A verificar os dados de acesso"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a555579231 = messageFormatterFn((function(  ) {
  return function(d) { return "Ocultar palavra-passe"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a869921370 = messageFormatterFn((function(  ) {
  return function(d) { return "Mostrar palavra-passe"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a1615235492 = messageFormatterFn((function(  ) {
  return function(d) { return "Não tem conta? <span><a id=\"createAcctRedirectLink\" href=" + d["0"] + ">Pode criar uma aqui</a></span>"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a568555753 = messageFormatterFn((function(  ) {
  return function(d) { return "Iniciar sessão"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.b1275652384 = messageFormatterFn((function(  ) {
  return function(d) { return "Já não é possível iniciar sessão através da " + d["0"]; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.b1899814460 = messageFormatterFn((function(  ) {
  return function(d) { return "Pode utilizar o mesmo endereço de e-mail para aceder à sua conta da " + d["0"] + " depois de redefinir a sua palavra-passe. Esta ação não irá afetar a sua conta da " + d["1"] + "."; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.b1029417998 = messageFormatterFn((function(  ) {
  return function(d) { return "Para redefinir a palavra-passe, selecione a opção indicada abaixo. Depois de concluir este passo, deverá utilizar o seu e-mail e a nova palavra-passe para iniciar sessão na " + d["0"] + "."; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.b1981600789 = messageFormatterFn((function(  ) {
  return function(d) { return "Início de sessão único (SSO)"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a911016435 = messageFormatterFn((function(  ) {
  return function(d) { return "Aceda através do início de sessão único"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a347851873 = messageFormatterFn((function(  ) {
  return function(d) { return "ou utilize a sua conta do " + d["0"]; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a1895960212 = messageFormatterFn((function(  ) {
  return function(d) { return "Ganhe pontos para viajar gratuitamente, poupe com os preços para membros e aceda facilmente aos seus itinerários."; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.b1144156242 = messageFormatterFn((function(  ) {
  return function(d) { return "Receba " + d["0"] + " pontos Expedia Rewards após a sua viagem."; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a969591285 = messageFormatterFn((function(  ) {
  return function(d) { return "Início de sessão na " + d["0"]; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.b962597111 = messageFormatterFn((function(  ) {
  return function(d) { return "Palavra-passe esquecida"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a1260057550 = messageFormatterFn((function(  ) {
  return function(d) { return "Redefina a sua palavra-passe"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a476021528 = messageFormatterFn((function(  ) {
  return function(d) { return "Introduza o seu e-mail e enviar-lhe-emos uma hiperligação para redefinir a sua palavra-passe."; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.b761156268 = messageFormatterFn((function(  ) {
  return function(d) { return "Enviar link de redefinição"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a503059727 = messageFormatterFn((function(  ) {
  return function(d) { return "Verifique a sua caixa de entrada"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a1633079735 = messageFormatterFn((function(  ) {
  return function(d) { return "Enviámos um e-mail para " + d["0"] + " com uma hiperligação para redefinir a sua palavra-passe."; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a1633080696 = messageFormatterFn((function(  ) {
  return function(d) { return "Este poderá demorar alguns minutos até chegar à sua caixa de entrada. Se não tiver recebido um e-mail após 10 minutos, verifique a sua pasta de lixo ou spam."; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a1800869278 = messageFormatterFn((function(  ) {
  return function(d) { return "Reenviar hiperligação"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.b1763749542 = messageFormatterFn((function(  ) {
  return function(d) { return "Foi enviada uma nova hiperligação."; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a863682739 = messageFormatterFn((function(  ) {
  return function(d) { return "A verificar a conta"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.b770261773 = messageFormatterFn((function(  ) {
  return function(d) { return "Definir palavra-passe"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a1635739044 = messageFormatterFn((function(  ) {
  return function(d) { return "Estávamos com saudades suas!"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.b281364094 = messageFormatterFn((function(  ) {
  return function(d) { return "Crie uma palavra-passe exclusiva para prosseguir"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.b529214285 = messageFormatterFn((function(  ) {
  return function(d) { return "Já está!"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a1805470698 = messageFormatterFn((function(  ) {
  return function(d) { return "Utilize agora a sua nova palavra-passe para continuar."; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.b327359461 = messageFormatterFn((function(  ) {
  return function(d) { return "Redefina a palavra-passe"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.b289497726 = messageFormatterFn((function(  ) {
  return function(d) { return "Lamentamos, mas este pedido expirou. Caso ainda precise de alterar a sua palavra-passe, clique na hiperligação em baixo para receber um e-mail de redefinição da palavra-passe."; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a1794464530 = messageFormatterFn((function(  ) {
  return function(d) { return "Reenviar hiperligação"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a1277732797 = messageFormatterFn((function(  ) {
  return function(d) { return "A guardar a palavra-passe"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a1288511471 = messageFormatterFn((function(  ) {
  return function(d) { return "Criar uma conta"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a1391037085 = messageFormatterFn((function(  ) {
  return function(d) { return "Criar uma conta"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a724249006 = messageFormatterFn((function(  ) {
  return function(d) { return "Endereço de e-mail"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.b491103706 = messageFormatterFn((function(  ) {
  return function(d) { return "Introduza o seu endereço de e-mail."; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a1238300919 = messageFormatterFn((function(  ) {
  return function(d) { return "Introduza um endereço de e-mail válido."; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.b1021045811 = messageFormatterFn((function(  ) {
  return function(d) { return "Nome próprio"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.b969521083 = messageFormatterFn((function(  ) {
  return function(d) { return "Introduza o seu nome próprio."; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.b243843471 = messageFormatterFn((function(  ) {
  return function(d) { return "Apelido"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.b242181383 = messageFormatterFn((function(  ) {
  return function(d) { return "Introduza o seu apelido."; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.b2014560270 = messageFormatterFn((function(  ) {
  return function(d) { return "Introduza apenas letras"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a606538987 = messageFormatterFn((function(  ) {
  return function(d) { return "Palavra-passe"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a608201075 = messageFormatterFn((function(  ) {
  return function(d) { return "Introduza a sua palavra-passe."; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.b1126298366 = messageFormatterFn((function(  ) {
  return function(d) { return "Introduza uma palavra-passe válida."; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a49461118 = messageFormatterFn((function(  ) {
  return function(d) { return "Deve ter entre 9 e 64 caracteres"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a49462079 = messageFormatterFn((function(  ) {
  return function(d) { return "Deve ser uma combinação de letras e números"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a49463040 = messageFormatterFn((function(  ) {
  return function(d) { return "Deve incluir um carácter especial (p. ex., ~ " + "#" + " @ $ % & ! * _ ? ^ -)"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a49464001 = messageFormatterFn((function(  ) {
  return function(d) { return "A palavra-passe não pode conter espaços"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.b574159560 = messageFormatterFn((function(  ) {
  return function(d) { return "A palavra-passe deve ter entre 8 e 64 caracteres"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.b1057929371 = messageFormatterFn((function(  ) {
  return function(d) { return "A palavra-passe não pode ser igual ao endereço de e-mail."; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.b2147385374 = messageFormatterFn((function(  ) {
  return function(d) { return "A palavra-passe não pode conter espaços."; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.b1014376038 = messageFormatterFn((function(  ) {
  return function(d) { return "Ao criar uma conta, confirma que aceita os <a href=" + d["1"] + " " + d["3"] + ">Termos e Condições</a> e a <a href=" + d["2"] + " " + d["4"] + ">Declaração de Privacidade</a> do " + d["0"] + "."; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.b7151352 = messageFormatterFn((function(  ) {
  return function(d) { return "Ao criar uma conta, confirma que aceita os <a href=" + d["1"] + " " + d["5"] + ">Termos e Condições</a> e a <a href=" + d["2"] + " " + d["6"] + ">Declaração de Privacidade</a> do " + d["0"] + ", bem como os <a href=" + d["3"] + " " + d["7"] + ">Termos e Condições do programa " + d["4"] + "</a>."; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.b276304343 = messageFormatterFn((function(  ) {
  return function(d) { return "Quero receber promoções de viagens, ofertas especiais e outras informações do " + d["0"] + " por e-mail."; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a72072934 = messageFormatterFn((function(  ) {
  return function(d) { return "Quero receber promoções de viagens, ofertas especiais e outras informações do " + d["0"] + " por e-mail. Pode cancelar a subscrição destes e-mails promocionais em qualquer altura."; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.b228336596 = messageFormatterFn((function(  ) {
  return function(d) { return "Quero receber sugestões de viagens, ofertas especiais e outras informações da " + d["0"] + " por e-mail."; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.b1805914685 = messageFormatterFn((function(  ) {
  return function(d) { return "Quero receber sugestões de viagens, ofertas especiais e outras informações da " + d["0"] + " por e-mail. Pode cancelar a subscrição destes e-mails promocionais em qualquer altura."; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.b1888374025 = messageFormatterFn((function(  ) {
  return function(d) { return "Continuar"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a1627083644 = messageFormatterFn((function(  ) {
  return function(d) { return "Já tem uma conta? <span><a id=\"signinRedirectLink\" href=" + d["0"] + ">Iniciar sessão</a></span>"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a9219073 = messageFormatterFn((function(  ) {
  return function(d) { return "Olá, " + d["0"] + "!"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a1439430821 = messageFormatterFn((function(  ) {
  return function(d) { return "A sua nova conta do " + d["0"] + " é o ponto de partida para uma viagem inesquecível."; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a718463406 = messageFormatterFn((function(  ) {
  return function(d) { return "Continuar"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a1999486819 = messageFormatterFn((function(  ) {
  return function(d) { return "Introduza uma palavra-passe mais segura para continuar"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a1143801640 = messageFormatterFn((function(  ) {
  return function(d) { return "Deverá conter pelo menos 8 caracteres."; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a860931660 = messageFormatterFn((function(  ) {
  return function(d) { return "Segurança da palavra-passe"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.b762018186 = messageFormatterFn((function(  ) {
  return function(d) { return "Pouco segura"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a383974677 = messageFormatterFn((function(  ) {
  return function(d) { return "Segura"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a826629867 = messageFormatterFn((function(  ) {
  return function(d) { return "Muito segura"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a1601323226 = messageFormatterFn((function(  ) {
  return function(d) { return "Evite substituições de letras comuns (como “@” em vez de “a”)."; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a1808402114 = messageFormatterFn((function(  ) {
  return function(d) { return "Evite escrever palavras comuns ao contrário."; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a136018678 = messageFormatterFn((function(  ) {
  return function(d) { return "Escreva algumas letras em maiúscula, mas não todas."; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.b35607273 = messageFormatterFn((function(  ) {
  return function(d) { return "Escreva algumas letras em maiúscula além da primeira."; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a966595301 = messageFormatterFn((function(  ) {
  return function(d) { return "Evite datas e anos que possam estar associados a si."; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.b674049701 = messageFormatterFn((function(  ) {
  return function(d) { return "Evite anos recentes."; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.b1773306890 = messageFormatterFn((function(  ) {
  return function(d) { return "Evite anos que possam estar associados a si."; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a843623607 = messageFormatterFn((function(  ) {
  return function(d) { return "Evite sequências de caracteres comuns."; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a1964263121 = messageFormatterFn((function(  ) {
  return function(d) { return "Evite palavras e caracteres repetidos."; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a440294773 = messageFormatterFn((function(  ) {
  return function(d) { return "Evite usar letras que aparecem em sequência no teclado."; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.b945711526 = messageFormatterFn((function(  ) {
  return function(d) { return "Adicione palavras menos comuns."; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.b2021751994 = messageFormatterFn((function(  ) {
  return function(d) { return "Utilize várias palavras, mas evite expressões comuns."; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.b938927063 = messageFormatterFn((function(  ) {
  return function(d) { return "Pode criar palavras-passe seguras sem utilizar símbolos, números ou maiúsculas."; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a509151472 = messageFormatterFn((function(  ) {
  return function(d) { return "Este endereço de e-mail está associado a uma conta da " + d["0"]; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a1967694942 = messageFormatterFn((function(  ) {
  return function(d) { return "Enviámos-lhe um link para concluir a criação da sua conta."; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a1635693965 = messageFormatterFn((function(  ) {
  return function(d) { return "Estamos a criar a sua conta"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.b1678485383 = messageFormatterFn((function(  ) {
  return function(d) { return "O nome próprio deve conter pelo menos duas letras"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a1588649813 = messageFormatterFn((function(  ) {
  return function(d) { return "O apelido deve conter pelo menos duas letras"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.b430435545 = messageFormatterFn((function(  ) {
  return function(d) { return "O nome próprio pode conter até 100 letras"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.b1458267645 = messageFormatterFn((function(  ) {
  return function(d) { return "O apelido pode conter até 100 letras"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.b909988766 = messageFormatterFn((function(  ) {
  return function(d) { return "O nome próprio não pode incluir caracteres especiais"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.b814158786 = messageFormatterFn((function(  ) {
  return function(d) { return "O apelido não pode incluir caracteres especiais"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a1383565120 = messageFormatterFn((function(  ) {
  return function(d) { return "Concordo com o seguinte:"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.b675430836 = messageFormatterFn((function(  ) {
  return function(d) { return "Confirmo que tenho, pelo menos, 18 anos e que li e concordo com os <a href=" + d["0"] + " " + d["1"] + ">Termos de Utilização</a> e com os " + d["4"] + "Termos e Condições da <a href=" + d["2"] + " " + d["3"] + "></a> (obrigatório)"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a1859052150 = messageFormatterFn((function(  ) {
  return function(d) { return "Concordo com a recolha e utilização dos meus dados pessoais conforme indicado na <a href=" + d["0"] + " " + d["1"] + ">Política de Privacidade</a> (obrigatório)"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.b480046697 = messageFormatterFn((function(  ) {
  return function(d) { return "Concordo com a partilha dos meus dados pessoais com terceiros na Coreia do Sul e no estrangeiro, conforme indicado na <a href=" + d["0"] + " " + d["1"] + ">Política de Privacidade</a> (obrigatório)"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.b32217772 = messageFormatterFn((function(  ) {
  return function(d) { return "Aceite os termos para prosseguir."; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.b637669680 = messageFormatterFn((function(  ) {
  return function(d) { return "Aceite os termos para continuar."; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.b515170612 = messageFormatterFn((function(  ) {
  return function(d) { return "Selecione a caixa para continuar."; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.b1105193019 = messageFormatterFn((function(  ) {
  return function(d) { return "Em alternativa, crie uma conta com " + d["0"]; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a451360473 = messageFormatterFn((function(  ) {
  return function(d) { return "Evite usar espaços, o seu nome, o seu e-mail ou palavras-passe que tenha utilizado anteriormente."; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a641906595 = messageFormatterFn((function(  ) {
  return function(d) { return "Ocorreu um erro. Aguarde alguns minutos e depois tente novamente."; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a525316681 = messageFormatterFn((function(  ) {
  return function(d) { return "Verifique o seu n.º de telemóvel"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.b1876919558 = messageFormatterFn((function(  ) {
  return function(d) { return "Para garantir a segurança da sua conta, enviaremos um código de verificação único para o seu telemóvel."; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.b1151943891 = messageFormatterFn((function(  ) {
  return function(d) { return "Enviar"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a286683834 = messageFormatterFn((function(  ) {
  return function(d) { return "© " + d["1"] + " " + d["0"] + ". Todos os direitos reservados."; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.b1192698360 = messageFormatterFn((function(  ) {
  return function(d) { return "Termos e Condições"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a1240130121 = messageFormatterFn((function(  ) {
  return function(d) { return "Política de Privacidade"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a915450144 = messageFormatterFn((function(  ) {
  return function(d) { return "Enviar SMS"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a1620130549 = messageFormatterFn((function(  ) {
  return function(d) { return "Código de verificação"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a1588764839 = messageFormatterFn((function(  ) {
  return function(d) { return "Código de verificação"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a399903386 = messageFormatterFn((function(  ) {
  return function(d) { return "Reenviar código"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a1757830449 = messageFormatterFn((function(  ) {
  return function(d) { return "Alterar n.º de telemóvel"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.b848013661 = messageFormatterFn((function(  ) {
  return function(d) { return "O código de verificação foi reenviado."; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.b858190716 = messageFormatterFn((function(  ) {
  return function(d) { return "Introduza o código de verificação de 6 dígitos enviado para o " + d["0"] + "."; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.b82701751 = messageFormatterFn((function(  ) {
  return function(d) { return "A analisar o código de verificação"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a179815134 = messageFormatterFn((function(  ) {
  return function(d) { return "Este código não está correto. Solicite um novo código e tente novamente."; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a1701138216 = messageFormatterFn((function(  ) {
  return function(d) { return "ou aceda com"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a944926008 = messageFormatterFn((function(  ) {
  return function(d) { return "Ao registar-se gratuitamente, poderá poupar, em média, " + d["0"] + "% em milhares de hotéis."; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.b781577018 = messageFormatterFn((function(  ) {
  return function(d) { return "ou"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.b715546556 = messageFormatterFn((function(  ) {
  return function(d) { return "Outras formas de iniciar sessão"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.b715187142 = messageFormatterFn((function(  ) {
  return function(d) { return "Outras formas de criar uma conta"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.b1518216112 = messageFormatterFn((function(  ) {
  return function(d) { return "Criar conta através do Google"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a1571593263 = messageFormatterFn((function(  ) {
  return function(d) { return "Ocorreu um erro ao iniciar sessão. Tente novamente ou crie uma conta neste site para continuar."; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.b1928535 = messageFormatterFn((function(  ) {
  return function(d) { return "Não é possível iniciar sessão com um número de telefone. Certifique-se de que a conta da sua rede social tem um e-mail associado e que este pode ser partilhado."; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a656599457 = messageFormatterFn((function(  ) {
  return function(d) { return "Ao registar-se gratuitamente, poderá poupar " + d["0"] + "% ou mais em milhares de hotéis."; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a443005062 = messageFormatterFn((function(  ) {
  return function(d) { return "Iniciar sessão com o Google"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a837732677 = messageFormatterFn((function(  ) {
  return function(d) { return "Iniciar sessão com o NAVER"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a854557221 = messageFormatterFn((function(  ) {
  return function(d) { return "Excedeu o número máximo de tentativas de início de sessão. Tente novamente mais tarde."; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.b2132465928 = messageFormatterFn((function(  ) {
  return function(d) { return "Inicie sessão com os seus dados biométricos"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a2137750056 = messageFormatterFn((function(  ) {
  return function(d) { return "Esta é uma forma de aceder à sua conta sem precisar de introduzir a palavra-passe."; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a1775840661 = messageFormatterFn((function(  ) {
  return function(d) { return "Experimentar"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a1391652219 = messageFormatterFn((function(  ) {
  return function(d) { return "Lembrar-me mais tarde"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a705320751 = messageFormatterFn((function(  ) {
  return function(d) { return "Já está!"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a424124523 = messageFormatterFn((function(  ) {
  return function(d) { return "Ativou o acesso através dos seus dados biométricos."; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a2139450707 = messageFormatterFn((function(  ) {
  return function(d) { return "Iniciar sessão com os dados biométricos"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a1559888600 = messageFormatterFn((function(  ) {
  return function(d) { return "Utilizar a palavra-passe"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a658580989 = messageFormatterFn((function(  ) {
  return function(d) { return "Utilizar os dados biométricos"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a1711043626 = messageFormatterFn((function(  ) {
  return function(d) { return "Atualize a sua palavra-passe para continuar"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a1308987026 = messageFormatterFn((function(  ) {
  return function(d) { return "É necessário redefinir a palavra-passe para aceder à sua conta."; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.b1073890376 = messageFormatterFn((function(  ) {
  return function(d) { return "Redefinir a palavra-passe"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.b1764667832 = messageFormatterFn((function(  ) {
  return function(d) { return "Aproveite as vantagens para membros"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a1122194798 = messageFormatterFn((function(  ) {
  return function(d) { return "Como incentivo para começar a planear a sua próxima viagem, oferecemos-lhe pontos no valor de $" + d["0"] + "!"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a851534210 = messageFormatterFn((function(  ) {
  return function(d) { return "Estes pontos já estão disponíveis na sua conta e podem ser utilizados na sua primeira reserva. Basta procurar a opção para aplicar pontos na página de pagamento."; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.b472064080 = messageFormatterFn((function(  ) {
  return function(d) { return "Parabéns por ter criado uma conta na Expedia!"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.b1325850752 = messageFormatterFn((function(  ) {
  return function(d) { return "Comece já a poupar com os preços para membros e receba pontos sempre que reservar."; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a149770357 = messageFormatterFn((function(  ) {
  return function(d) { return "Inicie sessão ou crie uma conta"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a1886116421 = messageFormatterFn((function(  ) {
  return function(d) { return "Ao registar-se gratuitamente, poderá poupar, em média, " + d["0"] + "% em milhares de hotéis."; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a632233309 = messageFormatterFn((function(  ) {
  return function(d) { return "Ao continuar, confirma que leu e aceita os nossos <a href=" + d["1"] + " " + d["3"] + ">Termos e Condições</a> e a <a href=" + d["2"] + " " + d["4"] + ">Declaração de Privacidade</a>."; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a423825957 = messageFormatterFn((function(  ) {
  return function(d) { return "Ao continuar, confirma que leu e aceita os nossos <a href=" + d["1"] + " " + d["5"] + ">Termos e Condições</a>, a <a href=" + d["2"] + " " + d["6"] + ">Declaração de Privacidade</a> e os <a href=" + d["3"] + " " + d["7"] + ">Termos e Condições do programa " + d["4"] + "</a>."; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.b726114432 = messageFormatterFn((function(  ) {
  return function(d) { return "Ao continuar, confirma que leu e aceita os nossos <a href=" + d["1"] + " " + d["4"] + ">Termos e Condições</a>, a <a href=" + d["2"] + " " + d["5"] + ">Declaração de Privacidade</a>e os <a href=" + d["3"] + " " + d["6"] + ">Termos e Condições do programa de fidelização One Key</a>."; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.b1763255196 = messageFormatterFn((function(  ) {
  return function(d) { return "E-mail"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a128742814 = messageFormatterFn((function(  ) {
  return function(d) { return "Introduza um e-mail válido."; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a1449930913 = messageFormatterFn((function(  ) {
  return function(d) { return "Google"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a56633006 = messageFormatterFn((function(  ) {
  return function(d) { return "Facebook"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a1263167368 = messageFormatterFn((function(  ) {
  return function(d) { return "Apple"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.b2090868449 = messageFormatterFn((function(  ) {
  return function(d) { return "Recomendamos que apenas selecione esta caixa se estiver a utilizar um dispositivo pessoal. Para proteger a sua conta, não utilize esta opção em dispositivos partilhados."; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.b1714773202 = messageFormatterFn((function(  ) {
  return function(d) { return "Atingiu o limite de tentativas de acesso. Aguarde " + d["0"] + " minutos e tente novamente."; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.b1589241354 = messageFormatterFn((function(  ) {
  return function(d) { return "Atingiu o limite de tentativas de acesso. Aguarde " + d["0"] + " minuto e tente novamente."; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.b1584346020 = messageFormatterFn((function(  ) {
  return function(d) { return "Atingiu o limite de tentativas de acesso. Aguarde " + d["0"] + " minutos e tente novamente."; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.b1597803864 = messageFormatterFn((function(  ) {
  return function(d) { return "Atingiu o limite de tentativas de acesso. Aguarde " + d["0"] + " minutos e tente novamente."; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.b2090755803 = messageFormatterFn((function(  ) {
  return function(d) { return "Atingiu o limite de tentativas de acesso. Aguarde " + d["0"] + " minutos e tente novamente."; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a1923978976 = messageFormatterFn((function(  ) {
  return function(d) { return "Atingiu o limite de tentativas de acesso. Aguarde " + d["0"] + " minutos e tente novamente."; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a1966022863 = messageFormatterFn((function(  ) {
  return function(d) { return "Utilize apenas uma conta para receber recompensas na Expedia, no Hoteis.com e na Vrbo."; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a446917257 = messageFormatterFn((function(  ) {
  return function(d) { return "Utilize apenas uma conta na Expedia, no Hoteis.com e na Vrbo para tirar o máximo partido das suas viagens."; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a1486803216 = messageFormatterFn((function(  ) {
  return function(d) { return "Procure e guarde alojamentos, faça planos com o seu grupo e aceda às informações sobre a sua reserva."; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.b1880375025 = messageFormatterFn((function(  ) {
  return function(d) { return "A sua conta foi colocada em pausa durante uma verificação de segurança de rotina. As suas informações estão seguras. No entanto, deve redefinir a sua palavra-passe."; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a30247809 = messageFormatterFn((function(  ) {
  return function(d) { return "Inicie sessão e reserve a sua estadia para ganhar créditos OneKeyCash"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.b1746097933 = messageFormatterFn((function(  ) {
  return function(d) { return "É necessário confirmar a sua identidade"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a893831431 = messageFormatterFn((function(  ) {
  return function(d) { return "Introduza o código de segurança que recebeu por e-mail. Se não encontrar o código na sua caixa de entrada, verifique a pasta de lixo eletrónico."; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a727814917 = messageFormatterFn((function(  ) {
  return function(d) { return "Vamos confirmar o seu e-mail"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.b407253579 = messageFormatterFn((function(  ) {
  return function(d) { return "Para continuar, introduza o código de segurança que enviámos para " + d["0"] + ". Se não encontrar o código na sua caixa de entrada, verifique a pasta de lixo eletrónico."; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.b1681590991 = messageFormatterFn((function(  ) {
  return function(d) { return "Código de 6 dígitos"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a1267994673 = messageFormatterFn((function(  ) {
  return function(d) { return "Reenviar código"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a687032776 = messageFormatterFn((function(  ) {
  return function(d) { return "(0:" + d["0"] + ")"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a1417198352 = messageFormatterFn((function(  ) {
  return function(d) { return "Reenviar o código dentro de " + d["0"] + " s"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.b380222624 = messageFormatterFn((function(  ) {
  return function(d) { return "Não recebeu um e-mail?"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a462695102 = messageFormatterFn((function(  ) {
  return function(d) { return "Pode pedir outro código em " + d["0"] + " s"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a1619238699 = messageFormatterFn((function(  ) {
  return function(d) { return "Pedir outro código de segurança"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a1270551029 = messageFormatterFn((function(  ) {
  return function(d) { return "Enviámos um novo código de 6 dígitos para o seu e-mail."; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a933165056 = messageFormatterFn((function(  ) {
  return function(d) { return "Introduzir a palavra-passe"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.b460435775 = messageFormatterFn((function(  ) {
  return function(d) { return "Introduziu um código inválido. Tente novamente."; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.b1568934417 = messageFormatterFn((function(  ) {
  return function(d) { return "Este código expirou. Solicite um novo código e tente novamente."; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a14567780 = messageFormatterFn((function(  ) {
  return function(d) { return "Se não encontrar o código na sua caixa de entrada, verifique a pasta de lixo eletrónico."; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.b21136693 = messageFormatterFn((function(  ) {
  return function(d) { return "Fizemos algumas alterações e precisamos de confirmar o seu e-mail. Introduza o código de segurança que foi enviado para a sua caixa de entrada."; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a238394452 = messageFormatterFn((function(  ) {
  return function(d) { return "Ocorreu um erro. Tente novamente."; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a1345682717 = messageFormatterFn((function(  ) {
  return function(d) { return "Introduza o código de segurança que recebeu por e-mail para atualizar o seu método de início de sessão."; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a1577376329 = messageFormatterFn((function(  ) {
  return function(d) { return "Introduza a sua palavra-passe"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a1113646978 = messageFormatterFn((function(  ) {
  return function(d) { return "Enviar um código de segurança por e-mail"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a443670174 = messageFormatterFn((function(  ) {
  return function(d) { return "O e-mail e a palavra-passe não coincidem."; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.b1495922329 = messageFormatterFn((function(  ) {
  return function(d) { return "Crie uma palavra-passe"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.b1134735983 = messageFormatterFn((function(  ) {
  return function(d) { return "Crie uma palavra-passe"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.b978618455 = messageFormatterFn((function(  ) {
  return function(d) { return "Pode utilizar o mesmo endereço de e-mail e palavra-passe para iniciar sessão na Expedia, no Hoteis.com e na Vrbo."; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a399030487 = messageFormatterFn((function(  ) {
  return function(d) { return "Criar palavra-passe"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.b267615578 = messageFormatterFn((function(  ) {
  return function(d) { return "Defina uma palavra-passe para utilizar em conjunto com os restantes métodos de início de sessão seguro."; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.b997844261 = messageFormatterFn((function(  ) {
  return function(d) { return "Crie uma nova palavra-passe"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a776917509 = messageFormatterFn((function(  ) {
  return function(d) { return "Crie uma nova palavra-passe"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a2119184053 = messageFormatterFn((function(  ) {
  return function(d) { return "Agora pode iniciar sessão na Expedia, no Hoteis.com e na Vrbo com apenas uma conta. Crie uma nova palavra-passe segura para a sua conta única."; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a1071257163 = messageFormatterFn((function(  ) {
  return function(d) { return "Criar palavra-passe"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.b322132803 = messageFormatterFn((function(  ) {
  return function(d) { return "Alterar a palavra-passe"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.b614563309 = messageFormatterFn((function(  ) {
  return function(d) { return "Utilize uma palavra-passe segura e exclusiva."; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a1173462573 = messageFormatterFn((function(  ) {
  return function(d) { return "Atualizar palavra-passe"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.b939290086 = messageFormatterFn((function(  ) {
  return function(d) { return "Não foi possível atualizar a sua palavra-passe. Tente novamente."; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.b1970451784 = messageFormatterFn((function(  ) {
  return function(d) { return "Esqueceu-se da palavra-passe?"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a137368866 = messageFormatterFn((function(  ) {
  return function(d) { return "Introduza o seu e-mail para receber um código de segurança que lhe permitirá iniciar sessão."; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.b564527938 = messageFormatterFn((function(  ) {
  return function(d) { return "Enviar e-mail"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.b1680491510 = messageFormatterFn((function(  ) {
  return function(d) { return "Contacte-nos"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a22373413 = messageFormatterFn((function(  ) {
  return function(d) { return "Eliminar conta"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a1983567642 = messageFormatterFn((function(  ) {
  return function(d) { return "Fechar"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a59259198 = messageFormatterFn((function(  ) {
  return function(d) { return "Aguarde enquanto verificamos a sua conta."; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a789077569 = messageFormatterFn((function(  ) {
  return function(d) { return "Eliminar a conta"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.b1656285787 = messageFormatterFn((function(  ) {
  return function(d) { return "OK"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a1793530367 = messageFormatterFn((function(  ) {
  return function(d) { return "Deve completar a viagem antes de eliminar a sua conta"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.b1264022304 = messageFormatterFn((function(  ) {
  return function(d) { return "Para evitar problemas, terá de manter a sua conta para aceder à sua reserva e obter ajuda do serviço de apoio a clientes em caso de alterações de última hora."; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a126461107 = messageFormatterFn((function(  ) {
  return function(d) { return "Deve eliminar primeiro a sua conta de proprietário da Vrbo"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a983813028 = messageFormatterFn((function(  ) {
  return function(d) { return "Aceda à página de ajuda no site ou na aplicação para contactar o serviço de apoio a clientes e dar início ao processo."; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a61700564 = messageFormatterFn((function(  ) {
  return function(d) { return "Tente novamente depois de concluir as suas viagens."; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a1371214833 = messageFormatterFn((function(  ) {
  return function(d) { return "Indique o motivo:"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a1863168382 = messageFormatterFn((function(  ) {
  return function(d) { return "Recebo demasiados e-mails ou notificações"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a1295706388 = messageFormatterFn((function(  ) {
  return function(d) { return "Tenho outra conta na " + d["0"]; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a1255978575 = messageFormatterFn((function(  ) {
  return function(d) { return "Já concluí a minha viagem e não vou precisar mais desta conta"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.b350731307 = messageFormatterFn((function(  ) {
  return function(d) { return "Tive uma experiência negativa ao reservar com a " + d["0"] + " "; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.b1097472406 = messageFormatterFn((function(  ) {
  return function(d) { return "Outro motivo"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.b2136181485 = messageFormatterFn((function(  ) {
  return function(d) { return "Cancelar"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.b1940341542 = messageFormatterFn((function(  ) {
  return function(d) { return "Enviar"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.b383173654 = messageFormatterFn((function(  ) {
  return function(d) { return "Lamentamos que queira eliminar a sua conta. Antes de confirmar a sua decisão, leia estas informações importantes:"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.b2133241885 = messageFormatterFn((function(  ) {
  return function(d) { return "Perderá " + d["0"] + " pontos Expedia Rewards no valor de " + d["1"] + ", créditos no valor de " + d["2"] + ", quaisquer cupões e componentes de viagem guardados, bem como as preferências da conta."; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.b1617556114 = messageFormatterFn((function(  ) {
  return function(d) { return "Perderá " + d["0"] + " pontos Expedia Rewards no valor de " + d["1"] + ", quaisquer cupões e componentes de viagem guardados, bem como as preferências da conta."; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.b1191554064 = messageFormatterFn((function(  ) {
  return function(d) { return "Perderá os seus planos de viagem, os créditos e as suas preferências."; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a889076902 = messageFormatterFn((function(  ) {
  return function(d) { return "Hoteis.com Rewards: perderá " + d["0"] + " noite(s) de recompensa no valor de " + d["1"] + " e " + d["2"] + " carimbo(s) com um valor médio de " + d["3"] + "."; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a436744119 = messageFormatterFn((function(  ) {
  return function(d) { return "Perderá os seus créditos, quaisquer cupões e componentes de viagem guardados, bem como as preferências da conta."; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.b1167763617 = messageFormatterFn((function(  ) {
  return function(d) { return "Perderá " + d["0"] + " CheapCash no valor de " + d["1"] + ", créditos no valor de " + d["2"] + ", quaisquer cupões e componentes de viagem guardados, bem como as preferências da conta."; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.b870596494 = messageFormatterFn((function(  ) {
  return function(d) { return "Perderá " + d["0"] + " CheapCash no valor de " + d["1"] + ", quaisquer cupões e componentes de viagem guardados, bem como as preferências da conta."; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.b1939994473 = messageFormatterFn((function(  ) {
  return function(d) { return "Perderá " + d["0"] + " Orbucks no valor de " + d["1"] + ", créditos no valor de " + d["2"] + ", quaisquer cupões e componentes de viagem guardados, bem como as preferências da conta."; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a290888762 = messageFormatterFn((function(  ) {
  return function(d) { return "Perderá " + d["0"] + " Orbucks no valor de " + d["1"] + ", quaisquer cupões e componentes de viagem guardados, bem como as preferências da conta."; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.b1968868829 = messageFormatterFn((function(  ) {
  return function(d) { return "Perderá " + d["0"] + " MrJet Rewards no valor de " + d["1"] + ", créditos no valor de " + d["2"] + ", quaisquer cupões e componentes de viagem guardados, bem como as preferências da conta."; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a1118438190 = messageFormatterFn((function(  ) {
  return function(d) { return "Perderá " + d["0"] + " MrJet Rewards no valor de " + d["1"] + ", quaisquer cupões e componentes de viagem guardados, bem como as preferências da conta."; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.b1857112065 = messageFormatterFn((function(  ) {
  return function(d) { return "Perderá " + d["0"] + " BONUS+ no valor de " + d["1"] + ", créditos no valor de " + d["2"] + ", quaisquer cupões e componentes de viagem guardados, bem como as preferências da conta."; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a647871442 = messageFormatterFn((function(  ) {
  return function(d) { return "Perderá " + d["0"] + " BONUS+ no valor de " + d["1"] + ", quaisquer cupões e componentes de viagem guardados, bem como as preferências da conta."; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a191010441 = messageFormatterFn((function(  ) {
  return function(d) { return "Perderá quaisquer cupões e componentes de viagem guardados e as preferências da conta."; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a796600158 = messageFormatterFn((function(  ) {
  return function(d) { return "Perderá créditos no valor de " + d["0"] + ", quaisquer cupões e componentes de viagem guardados, bem como as preferências da conta."; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.b1393718248 = messageFormatterFn((function(  ) {
  return function(d) { return "Poderemos guardar algumas informações (p. ex., registos de transações) em segurança para cumprir determinadas obrigações legais ou para o caso de necessitarmos de exercer, defender ou fazer valer um direito legal. Estas informações serão mantidas em segurança e serão eliminadas, anonimizadas ou ofuscadas de forma permanente quando deixarem de ser necessárias."; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.b1660169260 = messageFormatterFn((function(  ) {
  return function(d) { return "Eliminar a conta permanentemente"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.b572511652 = messageFormatterFn((function(  ) {
  return function(d) { return "Manter a conta"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.b1025841966 = messageFormatterFn((function(  ) {
  return function(d) { return "Esperamos que volte a utilizar os nossos serviços no futuro"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.b556470541 = messageFormatterFn((function(  ) {
  return function(d) { return "Poderá demorar algumas semanas até que o pedido de eliminação da conta seja processado. Como tal, poderá continuar a receber comunicações enquanto atualizamos o nosso sistema."; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a1047242701 = messageFormatterFn((function(  ) {
  return function(d) { return "Tentar novamente"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a1916319988 = messageFormatterFn((function(  ) {
  return function(d) { return "Ocorreu um erro de sistema. Solicite novamente a eliminação da sua conta ou volte a tentar dentro de alguns minutos."; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.b1884588740 = messageFormatterFn((function(  ) {
  return function(d) { return "Fechar"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.b1536577771 = messageFormatterFn((function(  ) {
  return function(d) { return "Qual é o nome indicado no seu documento de identificação?"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.b1419354213 = messageFormatterFn((function(  ) {
  return function(d) { return "O nome da sua conta deve ser o mesmo que consta do seu documento de identificação (p. ex., passaporte ou carta de condução). Da próxima vez que reservar, não terá de introduzir esta informação."; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a1055864713 = messageFormatterFn((function(  ) {
  return function(d) { return "Receba promoções, ofertas e outras informações da " + d["0"] + " por e-mail."; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a636400006 = messageFormatterFn((function(  ) {
  return function(d) { return "Receba promoções, ofertas e outras informações da " + d["0"] + " por e-mail. Pode cancelar o envio de e-mails de marketing a qualquer momento."; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.b1239143103 = messageFormatterFn((function(  ) {
  return function(d) { return "Informações da conta"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a1017337943 = messageFormatterFn((function(  ) {
  return function(d) { return "Quero receber e-mails sobre promoções, ofertas e outras informações da " + d["0"] + ". Pode optar por não receber mais e-mails em qualquer altura."; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a537455859 = messageFormatterFn((function(  ) {
  return function(d) { return "Fique a par de tudo"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a1498219795 = messageFormatterFn((function(  ) {
  return function(d) { return "Consentimento de marketing"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.b681563870 = messageFormatterFn((function(  ) {
  return function(d) { return "Expedia Rewards"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a1052732800 = messageFormatterFn((function(  ) {
  return function(d) { return "CheapCash"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a185043832 = messageFormatterFn((function(  ) {
  return function(d) { return "Orbitz Rewards"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a195233440 = messageFormatterFn((function(  ) {
  return function(d) { return "BONUS+"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.b1623224542 = messageFormatterFn((function(  ) {
  return function(d) { return "MrJet"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.b1280852089 = messageFormatterFn((function(  ) {
  return function(d) { return "Hoteis.com Rewards"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.b270346843 = messageFormatterFn((function(  ) {
  return function(d) { return "One Key"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.b419875630 = messageFormatterFn((function(  ) {
  return function(d) { return "Tem de aguardar até que a sua viagem esteja concluída"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a1434952254 = messageFormatterFn((function(  ) {
  return function(d) { return "Tem de aguardar até realizar as suas viagens futuras"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.b2088296516 = messageFormatterFn((function(  ) {
  return function(d) { return "Se necessário, pode consultar as informações sobre a sua reserva ou obter ajuda através da sua conta. Tente novamente depois de concluir a sua viagem."; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.b2010127832 = messageFormatterFn((function(  ) {
  return function(d) { return "Se necessário, pode consultar as informações sobre a sua reserva ou obter ajuda através da sua conta. Tente novamente após a conclusão das suas viagens."; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.b1260286559 = messageFormatterFn((function(  ) {
  return function(d) { return "De momento, não é possível eliminar a sua conta"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a209588107 = messageFormatterFn((function(  ) {
  return function(d) { return "Esta conta também está a ser utilizada para anunciar alojamentos na Vrbo. Para eliminar a sua conta, tem de iniciar sessão na aplicação para proprietários ou no site da Vrbo e eliminar os seus anúncios ativos."; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a349335876 = messageFormatterFn((function(  ) {
  return function(d) { return "Indique-nos o motivo pelo qual pretende eliminar a sua conta."; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.b2580441 = messageFormatterFn((function(  ) {
  return function(d) { return "Tenho uma conta registada com outro e-mail"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.b698538456 = messageFormatterFn((function(  ) {
  return function(d) { return "Tive uma experiência de reserva negativa"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a1756822141 = messageFormatterFn((function(  ) {
  return function(d) { return "Lamentamos que queira eliminar a sua conta. A eliminação da sua conta é irreversível e terá impacto nos seus dados na Expedia, no Hoteis.com e na Vrbo. Antes de confirmar a sua decisão, leia estas informações importantes:"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a879516040 = messageFormatterFn((function(  ) {
  return function(d) { return "Lamentamos que queira eliminar a sua conta. A eliminação da sua conta é irreversível e terá impacto nos seus dados na Expedia, na Wotif, no Hoteis.com e na Vrbo. Antes de confirmar a sua decisão, leia estas informações importantes:"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a1317462943 = messageFormatterFn((function(  ) {
  return function(d) { return "Perderá definitivamente o histórico, as preferências e os itens guardados na sua conta em todos os sites da Expedia, do Hoteis.com e da Vrbo."; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.b713203414 = messageFormatterFn((function(  ) {
  return function(d) { return "Perderá definitivamente o histórico, as preferências e os itens guardados na sua conta em todos os sites da Expedia, da Wotif, do Hoteis.com e da Vrbo."; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.b470821229 = messageFormatterFn((function(  ) {
  return function(d) { return "Perderá definitivamente todos os seus créditos OneKeyCash, incluindo quaisquer créditos OneKeyCash pendentes, bem como o seu escalão no One Key e todas as respetivas vantagens."; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a1677184521 = messageFormatterFn((function(  ) {
  return function(d) { return "Perderá definitivamente quaisquer créditos OneKeyCash pendentes, bem como o seu escalão no One Key e todas as respetivas vantagens."; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.b1087743486 = messageFormatterFn((function(  ) {
  return function(d) { return "Perderá definitivamente os créditos OneKeyCash no valor de " + d["0"] + " e quaisquer créditos OneKeyCash pendentes, bem como o seu escalão no One Key e todas as respetivas vantagens."; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a258162964 = messageFormatterFn((function(  ) {
  return function(d) { return "Os titulares de cartões de crédito do programa Hoteis.com Rewards deixarão de receber recompensas com base na atividade do cartão."; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.b355896847 = messageFormatterFn((function(  ) {
  return function(d) { return "Perderá definitivamente todos os seus pontos Expedia Rewards, incluindo todos os pontos Expedia Rewards confirmados e pendentes, bem como os carimbos, as noites de recompensa e os escalões de recompensa do programa Hoteis.com Rewards."; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.b1367556505 = messageFormatterFn((function(  ) {
  return function(d) { return "Perderá definitivamente quaisquer pontos Expedia Rewards pendentes, bem como os carimbos, as noites de recompensa e os escalões de recompensa do programa Hoteis.com Rewards."; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a1420622957 = messageFormatterFn((function(  ) {
  return function(d) { return "Perderá definitivamente todos os cupões e créditos para utilizar na Expedia, no Hoteis.com ou na Vrbo."; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a1307912056 = messageFormatterFn((function(  ) {
  return function(d) { return "Perderá definitivamente todos os cupões e créditos para utilizar na Expedia, na Wotif, no Hoteis.com ou na Vrbo."; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a162038470 = messageFormatterFn((function(  ) {
  return function(d) { return "Poderá demorar algumas semanas até que o pedido de eliminação da conta da Expedia, do Hoteis.com e da Vrbo seja processado. Como tal, poderá continuar a receber comunicações enquanto atualizamos o nosso sistema."; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a29280017 = messageFormatterFn((function(  ) {
  return function(d) { return "Poderá demorar algumas semanas até que o pedido de eliminação da conta da Expedia, da Wotif, do Hoteis.com e da Vrbo seja processado. Como tal, poderá continuar a receber comunicações enquanto atualizamos o nosso sistema."; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.b279578821 = messageFormatterFn((function(  ) {
  return function(d) { return "O seu cartão One Key será descontinuado quando eliminar a sua conta e não poderá ganhar créditos OneKeyCash em nenhum pagamento. A Wells Fargo entrará em contacto com a confirmação de que o cartão foi descontinuado."; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a305914319 = messageFormatterFn((function(  ) {
  return function(d) { return "O seu cartão One Key+ será descontinuado quando eliminar a sua conta e não poderá ganhar créditos OneKeyCash em nenhum pagamento. A Wells Fargo entrará em contacto com a confirmação de que o cartão foi descontinuado."; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a1096629436 = messageFormatterFn((function(  ) {
  return function(d) { return "Inicie sessão ou crie uma conta para ganhar créditos OneKeyCash pela sua viagem"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.b1668907362 = messageFormatterFn((function(  ) {
  return function(d) { return "Inicie sessão ou crie uma conta para ganhar recompensas por esta estadia"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a1931675451 = messageFormatterFn((function(  ) {
  return function(d) { return "Reservar sem iniciar sessão"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.a1722146483 = messageFormatterFn((function(  ) {
  return function(d) { return "Início de sessão na conta da " + d["0"] + ": adicionar número de telemóvel"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.b1543592419 = messageFormatterFn((function(  ) {
  return function(d) { return "Ocorreu um erro"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.b1569949431 = messageFormatterFn((function(  ) {
  return function(d) { return "Tente iniciar sessão novamente."; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.b624075776 = messageFormatterFn((function(  ) {
  return function(d) { return "OK"; }
})(), Globalize("pt-PT").pluralGenerator({}));
Globalize.b1852845896 = dateToPartsFormatterFn({"2":Globalize("pt-PT").numberFormatter({"raw":"00"}),"4":Globalize("pt-PT").numberFormatter({"raw":"0000"})}, {"pattern":"yyyy-MM-dd","timeSeparator":":"});
Globalize.a1327575032 = dateToPartsFormatterFn({"2":Globalize("pt-PT").numberFormatter({"raw":"00"}),"4":Globalize("pt-PT").numberFormatter({"raw":"0000"})}, {"pattern":"dd/MM/yyyy","timeSeparator":":"});
Globalize.b509363637 = dateToPartsFormatterFn({"1":Globalize("pt-PT").numberFormatter({"raw":"0"}),"4":Globalize("pt-PT").numberFormatter({"raw":"0000"})}, {"pattern":"d/M/yyyy","timeSeparator":":"});
Globalize.b1631817595 = dateToPartsFormatterFn({"1":Globalize("pt-PT").numberFormatter({"raw":"0"}),"4":Globalize("pt-PT").numberFormatter({"raw":"0000"})}, {"pattern":"yyyy/M/d","timeSeparator":":"});
Globalize.a1381716056 = dateToPartsFormatterFn({"2":Globalize("pt-PT").numberFormatter({"raw":"00"}),"4":Globalize("pt-PT").numberFormatter({"raw":"0000"})}, {"pattern":"dd.MM.yyyy","timeSeparator":":"});
Globalize.b2055660467 = dateToPartsFormatterFn({"1":Globalize("pt-PT").numberFormatter({"raw":"0"}),"4":Globalize("pt-PT").numberFormatter({"raw":"0000"})}, {"pattern":"d.M.yyyy","timeSeparator":":"});
Globalize.b1115529224 = dateToPartsFormatterFn({"2":Globalize("pt-PT").numberFormatter({"raw":"00"}),"4":Globalize("pt-PT").numberFormatter({"raw":"0000"})}, {"pattern":"yyyy/MM/dd","timeSeparator":":"});
Globalize.a1435857080 = dateToPartsFormatterFn({"2":Globalize("pt-PT").numberFormatter({"raw":"00"}),"4":Globalize("pt-PT").numberFormatter({"raw":"0000"})}, {"pattern":"dd-MM-yyyy","timeSeparator":":"});
Globalize.a1965351352 = dateToPartsFormatterFn({"2":Globalize("pt-PT").numberFormatter({"raw":"00"}),"4":Globalize("pt-PT").numberFormatter({"raw":"0000"})}, {"pattern":"MM/dd/yyyy","timeSeparator":":"});
Globalize.b750935029 = dateToPartsFormatterFn({"1":Globalize("pt-PT").numberFormatter({"raw":"0"}),"4":Globalize("pt-PT").numberFormatter({"raw":"0000"})}, {"pattern":"M/d/yyyy","timeSeparator":":"});
Globalize.a663296088 = dateToPartsFormatterFn({"2":Globalize("pt-PT").numberFormatter({"raw":"00"}),"4":Globalize("pt-PT").numberFormatter({"raw":"0000"})}, {"pattern":"yyyy.MM.dd","timeSeparator":":"});
Globalize.a400477351 = dateToPartsFormatterFn({}, {"pattern":"EEEEE","timeSeparator":":","days":{"E":{"5":{"sun":"D","mon":"S","tue":"T","wed":"Q","thu":"Q","fri":"S","sat":"S"}}}});
Globalize.a844171768 = dateToPartsFormatterFn({}, {"pattern":"EEEE","timeSeparator":":","days":{"E":{"4":{"sun":"domingo","mon":"segunda-feira","tue":"terça-feira","wed":"quarta-feira","thu":"quinta-feira","fri":"sexta-feira","sat":"sábado"}}}});
Globalize.b409073672 = dateToPartsFormatterFn({}, {"pattern":"MMMM","timeSeparator":":","months":{"M":{"4":{"1":"janeiro","2":"fevereiro","3":"março","4":"abril","5":"maio","6":"junho","7":"julho","8":"agosto","9":"setembro","10":"outubro","11":"novembro","12":"dezembro"}}}});
Globalize.b1187184664 = dateToPartsFormatterFn({"1":Globalize("pt-PT").numberFormatter({"raw":"0"})}, {"pattern":"d","timeSeparator":":"});
Globalize.b568461973 = dateToPartsFormatterFn({"1":Globalize("pt-PT").numberFormatter({"raw":"0"}),"2":Globalize("pt-PT").numberFormatter({"raw":"00"})}, {"pattern":"M/d/yy","timeSeparator":":"});
Globalize.a1316226422 = dateToPartsFormatterFn({"1":Globalize("pt-PT").numberFormatter({"raw":"0"}),"2":Globalize("pt-PT").numberFormatter({"raw":"00"})}, {"pattern":"d/MM","timeSeparator":":"});
Globalize.a2128952275 = dateToPartsFormatterFn({"1":Globalize("pt-PT").numberFormatter({"raw":"0"})}, {"pattern":"d 'de' MMMM","timeSeparator":":","months":{"M":{"4":{"1":"janeiro","2":"fevereiro","3":"março","4":"abril","5":"maio","6":"junho","7":"julho","8":"agosto","9":"setembro","10":"outubro","11":"novembro","12":"dezembro"}}}});
Globalize.b664935102 = dateToPartsFormatterFn({"1":Globalize("pt-PT").numberFormatter({"raw":"0"})}, {"pattern":"d 'de' MMMM 'de' y","timeSeparator":":","months":{"M":{"4":{"1":"janeiro","2":"fevereiro","3":"março","4":"abril","5":"maio","6":"junho","7":"julho","8":"agosto","9":"setembro","10":"outubro","11":"novembro","12":"dezembro"}}}});
Globalize.a1502510494 = dateToPartsFormatterFn({"1":Globalize("pt-PT").numberFormatter({"raw":"0"})}, {"pattern":"MMMM 'de' y","timeSeparator":":","months":{"M":{"4":{"1":"janeiro","2":"fevereiro","3":"março","4":"abril","5":"maio","6":"junho","7":"julho","8":"agosto","9":"setembro","10":"outubro","11":"novembro","12":"dezembro"}}}});
Globalize.a1503195687 = dateToPartsFormatterFn({"1":Globalize("pt-PT").numberFormatter({"raw":"0"}),"2":Globalize("pt-PT").numberFormatter({"raw":"00"})}, {"pattern":"d/MM/y","timeSeparator":":"});
Globalize.b2014678346 = dateToPartsFormatterFn({"1":Globalize("pt-PT").numberFormatter({"raw":"0"})}, {"pattern":"EEEE, d/MMM","timeSeparator":":","days":{"E":{"4":{"sun":"domingo","mon":"segunda-feira","tue":"terça-feira","wed":"quarta-feira","thu":"quinta-feira","fri":"sexta-feira","sat":"sábado"}}},"months":{"M":{"3":{"1":"jan.","2":"fev.","3":"mar.","4":"abr.","5":"mai.","6":"jun.","7":"jul.","8":"ago.","9":"set.","10":"out.","11":"nov.","12":"dez."}}}});
Globalize.a2121564107 = dateToPartsFormatterFn({"1":Globalize("pt-PT").numberFormatter({"raw":"0"}),"2":Globalize("pt-PT").numberFormatter({"raw":"00"})}, {"pattern":"E, d/MM","timeSeparator":":","days":{"E":{"1":{"sun":"domingo","mon":"segunda","tue":"terça","wed":"quarta","thu":"quinta","fri":"sexta","sat":"sábado"}}}});
Globalize.b1474132145 = dateFormatterFn(Globalize("pt-PT").dateToPartsFormatter({"raw":"yyyy-MM-dd"}));
Globalize.a1706288783 = dateFormatterFn(Globalize("pt-PT").dateToPartsFormatter({"raw":"dd/MM/yyyy"}));
Globalize.a1305553570 = dateFormatterFn(Globalize("pt-PT").dateToPartsFormatter({"raw":"d/M/yyyy"}));
Globalize.a183099612 = dateFormatterFn(Globalize("pt-PT").dateToPartsFormatter({"raw":"yyyy/M/d"}));
Globalize.a1760429807 = dateFormatterFn(Globalize("pt-PT").dateToPartsFormatter({"raw":"dd.MM.yyyy"}));
Globalize.b240743260 = dateFormatterFn(Globalize("pt-PT").dateToPartsFormatter({"raw":"d.M.yyyy"}));
Globalize.b736815473 = dateFormatterFn(Globalize("pt-PT").dateToPartsFormatter({"raw":"yyyy/MM/dd"}));
Globalize.a1814570831 = dateFormatterFn(Globalize("pt-PT").dateToPartsFormatter({"raw":"dd-MM-yyyy"}));
Globalize.b1950902193 = dateFormatterFn(Globalize("pt-PT").dateToPartsFormatter({"raw":"MM/dd/yyyy"}));
Globalize.a1063982178 = dateFormatterFn(Globalize("pt-PT").dateToPartsFormatter({"raw":"M/d/yyyy"}));
Globalize.a1042009839 = dateFormatterFn(Globalize("pt-PT").dateToPartsFormatter({"raw":"yyyy.MM.dd"}));
Globalize.a249303984 = dateFormatterFn(Globalize("pt-PT").dateToPartsFormatter({"raw":"EEEEE"}));
Globalize.a8011215 = dateFormatterFn(Globalize("pt-PT").dateToPartsFormatter({"raw":"EEEE"}));
Globalize.b1245234225 = dateFormatterFn(Globalize("pt-PT").dateToPartsFormatter({"raw":"MMMM"}));
Globalize.b603901071 = dateFormatterFn(Globalize("pt-PT").dateToPartsFormatter({"raw":"d"}));
Globalize.b959869054 = dateFormatterFn(Globalize("pt-PT").dateToPartsFormatter({"raw":"M/d/yy"}));
Globalize.a1744084991 = dateFormatterFn(Globalize("pt-PT").dateToPartsFormatter({"skeleton":"MMMd"}));
Globalize.b1787301270 = dateFormatterFn(Globalize("pt-PT").dateToPartsFormatter({"skeleton":"MMMMd"}));
Globalize.b1809710709 = dateFormatterFn(Globalize("pt-PT").dateToPartsFormatter({"skeleton":"yMMMMd"}));
Globalize.a1881224245 = dateFormatterFn(Globalize("pt-PT").dateToPartsFormatter({"skeleton":"yMMMM"}));
Globalize.a1881909438 = dateFormatterFn(Globalize("pt-PT").dateToPartsFormatter({"skeleton":"yMMMd"}));
Globalize.a1662558399 = dateFormatterFn(Globalize("pt-PT").dateToPartsFormatter({"skeleton":"MMMEEEEd"}));
Globalize.b1794689438 = dateFormatterFn(Globalize("pt-PT").dateToPartsFormatter({"skeleton":"MMMEd"}));
Globalize.a139929598 = dateParserFn(Globalize("pt-PT").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"yyyy-MM-dd","digitsRe":/\d/});
Globalize.b974616770 = dateParserFn(Globalize("pt-PT").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"dd/MM/yyyy","digitsRe":/\d/});
Globalize.a516172561 = dateParserFn(Globalize("pt-PT").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d/M/yyyy","digitsRe":/\d/});
Globalize.b606281397 = dateParserFn(Globalize("pt-PT").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"yyyy/M/d","digitsRe":/\d/});
Globalize.b920475746 = dateParserFn(Globalize("pt-PT").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"dd.MM.yyyy","digitsRe":/\d/});
Globalize.b1030124269 = dateParserFn(Globalize("pt-PT").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d.M.yyyy","digitsRe":/\d/});
Globalize.a877246270 = dateParserFn(Globalize("pt-PT").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"yyyy/MM/dd","digitsRe":/\d/});
Globalize.b866334722 = dateParserFn(Globalize("pt-PT").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"dd-MM-yyyy","digitsRe":/\d/});
Globalize.b336840450 = dateParserFn(Globalize("pt-PT").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"MM/dd/yyyy","digitsRe":/\d/});
Globalize.a274601169 = dateParserFn(Globalize("pt-PT").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"M/d/yyyy","digitsRe":/\d/});
Globalize.b1638895714 = dateParserFn(Globalize("pt-PT").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"yyyy.MM.dd","digitsRe":/\d/});
Globalize.a2055438753 = dateParserFn(Globalize("pt-PT").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"EEEEE","digitsRe":/\d/,"gregorian/days/format/narrow":[["sun",/^D/],["mon",/^S/],["tue",/^T/],["wed",/^Q/],["thu",/^Q/],["fri",/^S/],["sat",/^S/]]});
Globalize.b903557698 = dateParserFn(Globalize("pt-PT").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"EEEE","digitsRe":/\d/,"gregorian/days/format/wide":[["mon",/^segunda-feira/],["wed",/^quarta-feira/],["thu",/^quinta-feira/],["tue",/^terça-feira/],["fri",/^sexta-feira/],["sun",/^domingo/],["sat",/^sábado/]]});
Globalize.a2138164158 = dateParserFn(Globalize("pt-PT").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"MMMM","digitsRe":/\d/,"gregorian/months/format/wide":[["2",/^fevereiro/],["9",/^setembro/],["11",/^novembro/],["12",/^dezembro/],["1",/^janeiro/],["10",/^outubro/],["8",/^agosto/],["3",/^março/],["4",/^abril/],["6",/^junho/],["7",/^julho/],["5",/^maio/]]});
Globalize.a2133279202 = dateParserFn(Globalize("pt-PT").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d","digitsRe":/\d/});
Globalize.b804266063 = dateParserFn(Globalize("pt-PT").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"M/d/yy","digitsRe":/\d/});
Globalize.b1251889808 = dateParserFn(Globalize("pt-PT").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d/MM","digitsRe":/\d/});
Globalize.b173239527 = dateParserFn(Globalize("pt-PT").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d 'de' MMMM","digitsRe":/\d/,"gregorian/months/format/wide":[["2",/^fevereiro/],["9",/^setembro/],["11",/^novembro/],["12",/^dezembro/],["1",/^janeiro/],["10",/^outubro/],["8",/^agosto/],["3",/^março/],["4",/^abril/],["6",/^junho/],["7",/^julho/],["5",/^maio/]]});
Globalize.a981563068 = dateParserFn(Globalize("pt-PT").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d 'de' MMMM 'de' y","digitsRe":/\d/,"gregorian/months/format/wide":[["2",/^fevereiro/],["9",/^setembro/],["11",/^novembro/],["12",/^dezembro/],["1",/^janeiro/],["10",/^outubro/],["8",/^agosto/],["3",/^março/],["4",/^abril/],["6",/^junho/],["7",/^julho/],["5",/^maio/]]});
Globalize.b799681308 = dateParserFn(Globalize("pt-PT").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"MMMM 'de' y","digitsRe":/\d/,"gregorian/months/format/wide":[["2",/^fevereiro/],["9",/^setembro/],["11",/^novembro/],["12",/^dezembro/],["1",/^janeiro/],["10",/^outubro/],["8",/^agosto/],["3",/^março/],["4",/^abril/],["6",/^junho/],["7",/^julho/],["5",/^maio/]]});
Globalize.b798996115 = dateParserFn(Globalize("pt-PT").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d/MM/y","digitsRe":/\d/});
Globalize.b277901904 = dateParserFn(Globalize("pt-PT").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"EEEE, d/MMM","digitsRe":/\d/,"gregorian/days/format/wide":[["mon",/^segunda-feira/],["wed",/^quarta-feira/],["thu",/^quinta-feira/],["tue",/^terça-feira/],["fri",/^sexta-feira/],["sun",/^domingo/],["sat",/^sábado/]],"gregorian/months/format/abbreviated":[["1",/^jan\./],["2",/^fev\./],["3",/^mar\./],["4",/^abr\./],["5",/^mai\./],["6",/^jun\./],["7",/^jul\./],["8",/^ago\./],["9",/^set\./],["10",/^out\./],["11",/^nov\./],["12",/^dez\./]]});
Globalize.b180627695 = dateParserFn(Globalize("pt-PT").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"E, d/MM","digitsRe":/\d/,"gregorian/days/format/abbreviated":[["sun",/^domingo/],["mon",/^segunda/],["wed",/^quarta/],["thu",/^quinta/],["sat",/^sábado/],["tue",/^terça/],["fri",/^sexta/]]});
module.exports = Globalize;
